// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2z4yX","rootSuccess":"CompleteLink_rootSuccess__20gao","rootFailure":"CompleteLink_rootFailure__3m6rm","isDisabled":"CompleteLink_isDisabled__rA61l"};